module.exports = __webpack_public_path__ + "static/img/1.8aca6592.png";